<img class="picture" src="assets/404.svg" alt="404" />
<span class="bold" translate>NOTFOUND.NO_CHANCE</span>
<span translate>NOTFOUND.PAGE_DOESNT_EXISTS</span>
<rk-button [label]="'NOTFOUND.GOBACK' | translate" (click)="back()"></rk-button>
